import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import { Box, height, maxHeight, minHeight } from "@mui/system";
import {
  Chip,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";

import { useOutletContext } from "react-router-dom";
import api from "../../../../services/api";
import { useEffect, useRef, useState } from "react";
import AvailabilityGraphComponent from "../../../../components/disponibilidade/availabilityGraphComponent";
import dayjs from "dayjs";
import DatagridComponent from "../../../../components/datagridComponent";
import apiCliente from "../../../../services/apiCliente";
import SeverityChip from "../../../../components/severityChip";

export default function DisponibilidadeClient() {
  const theme = useTheme();
  const styles = useStyles(theme);

  const {
    filterData,
    handleAplicarZoom,
    setLoadingCronometro,
    selectTime,
    optionsTime,
    startCronometro,
    controllerDashboard,
    setControllerDashboard,
    toggleDrawer,
    stopCronometro,
    deviceConfig,
  } = useOutletContext();

  const [hostAvailability, setHostAvailability] = useState([]);
  const [interfaceAvailability, setInterfaceAvailability] = useState([]);
  const [hostHistory, setHostHistory] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [interfaceHistory, setInterfaceHistory] = useState([]);
  const [loadingAlerts, setLoadingAlerts] = useState(false);
  const [loadingAvailability, setLoadingAvailability] = useState({
    host: false,
    interface: false,
  });
  const [loadingAvailabilityHistory, setLoadingAvailabilityHistory] = useState({
    host: false,
    interface: false,
  });
  const clearData = () => {
    setHostAvailability([]);
    setInterfaceAvailability([]);
    setHostHistory([]);
    setAlerts([]);
    setInterfaceHistory([]);
  };
  const fetchAllData = async () => {
    stopCronometro();
    setLoadingCronometro(true);
    let dateInitial = filterData?.initialDate;
    let finalDate = filterData?.finalDate;

    if (selectTime || selectTime === 0) {
      dateInitial = optionsTime[selectTime]?.value;
      finalDate = dayjs().set("second", 0).set("millisecond", 0).toDate();
    }
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);

    await Promise.all([
      getAvailabilityHost(dateInitial, finalDate, signal),
      getAvailabilityInterface(dateInitial, finalDate, signal),
      getAvailabilityHistoryInterface(dateInitial, finalDate, signal),
      getAvailabilityHistoryHost(dateInitial, finalDate, signal),
      getAlerts(dateInitial, finalDate, signal),
    ]);
    if (!signal.aborted) {
      setLoadingCronometro(false);
      startCronometro();
    }
  };
  useEffect(() => {
    if (
      filterData?.interfaceId &&
      filterData?.hostId &&
      filterData?.initialDate &&
      filterData?.finalDate
    ) {
      /* 	setHostAvailability([]);
				setInterfaceAvailability([]); */
      fetchAllData();
      toggleDrawer(false)();
    } else {
      clearData();
    }
  }, [filterData]);

  const getAvailabilityHost = async (dateInitial, finalDate, signal) => {
    setLoadingAvailability((prev) => ({ ...prev, host: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "statusPing",
          exactMatch: true,
          percent: true,
          fillGap: 0,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "availability",
        },
        { signal },
      );

      setHostAvailability(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingAvailability((prev) => ({ ...prev, host: false }));
      }
    }
  };

  const getAvailabilityInterface = async (dateInitial, finalDate, signal) => {
    setLoadingAvailability((prev) => ({ ...prev, interface: true }));

    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "statusInterface",
          percent: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "availability",
        },
        { signal },
      );

      setInterfaceAvailability(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingAvailability((prev) => ({ ...prev, interface: false }));
      }
    }
  };

  const getAvailabilityHistoryHost = async (dateInitial, finalDate, signal) => {
    setLoadingAvailabilityHistory((prev) => ({ ...prev, host: true }));

    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/trending",
        {
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          itemsKeys: "icmpping",
          percent: true,
        },
        { signal },
      );
      const dataHistory = Array.isArray(response?.data)
        ? response?.data?.map((history, index) => ({
            ...history,
            id: index,
            mean: (history?.mean * 100).toFixed(2),
          }))
        : [];
      setHostHistory(dataHistory);

      /* setInterfaceAvailability(response?.data || []); */
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingAvailabilityHistory((prev) => ({ ...prev, host: false }));
      }
    }
  };

  const getAvailabilityHistoryInterface = async (
    dateInitial,
    finalDate,
    signal,
  ) => {
    setLoadingAvailabilityHistory((prev) => ({ ...prev, interface: true }));

    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/trending",
        {
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          itemsKeys: "ifOperStatus",
          percent: true,
        },
        { signal },
      );
      const dataHistory = Array.isArray(response?.data)
        ? response?.data?.map((history, index) => ({
            ...history,
            id: index,
            mean: (history?.mean * 100).toFixed(2),
          }))
        : [];
      setInterfaceHistory(dataHistory);

      /* setInterfaceAvailability(response?.data || []); */
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingAvailabilityHistory((prev) => ({
          ...prev,
          interface: false,
        }));
      }
    }
  };
  const getAlerts = async (dateInitial, finalDate, signal) => {
    setLoadingAlerts(true);
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/items/alerts",
        {
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          equipment: filterData?.device,
          alertType: "availability",
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "availability",
          // O clienteId é resolvido pelo token no backend, nunca enviado aqui
          servicoId: filterData?.serviceId,
        },
        { signal },
      );
      setAlerts(
        response?.data?.map((item, index) => {
          return {
            ...item,
            id: index,
          };
        }) || [],
      );
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingAlerts(false);
      }
    }
  };

  useEffect(() => {
    if (!controllerDashboard) return;
    return controllerDashboard.abort();
  }, []);

  const columns = [
    {
      field: "alert",
      headerName: "Alerta",
      flex: 2,
      valueFormatter: (params) => params?.replaceAll('"', ""),
    },
    {
      field: "severity",
      headerName: "Severidade",
      flex: 1,
      renderCell: (params) => (
        <SeverityChip severity={params?.row?.severity} theme={theme} />
      ),
    },
    {
      field: "initialDate",
      headerName: "Horário Ocorrência",
      flex: 1.5,
      valueFormatter: (params) =>
        dayjs.unix(Number(params)).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      field: "recoveryDate",
      headerName: "Horário Recuperação",
      flex: 1.5,
      valueFormatter: (params) =>
        dayjs.unix(Number(params)).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      field: "duration",
      headerName: "Duração",
      flex: 1,
      valueFormatter: (params) => {
        const totalMs = Number(params);
        if (!params || isNaN(totalMs) || totalMs <= 0) {
          return "";
        }
        const yearMs = 31536000000;
        const monthMs = 2592000000;
        const dayMs = 86400000;
        const hourMs = 3600000;
        const minuteMs = 60000;
        const secondMs = 1000;

        let remaining = totalMs;
        const years = Math.floor(remaining / yearMs);
        remaining %= yearMs;

        const months = Math.floor(remaining / monthMs);
        remaining %= monthMs;

        const days = Math.floor(remaining / dayMs);
        remaining %= dayMs;

        const hours = Math.floor(remaining / hourMs);
        remaining %= hourMs;

        const minutes = Math.floor(remaining / minuteMs);
        remaining %= minuteMs;

        const seconds = Math.floor(remaining / secondMs);

        const parts = [];
        if (years > 0) parts.push(`${years}a`);
        if (months > 0) parts.push(`${months}mes`);
        if (days > 0) parts.push(`${days}d`);
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}m`);
        if (seconds > 0) parts.push(`${seconds}s`);

        return parts.join(" ");
      },
    },
  ];

  //CHAMAR ROTAS ==========================================================

  return (
    <Box sx={styles.container}>
      <Grid
        container
        columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
        flexGrow={1}
        spacing={1}
      >
        <Grid item xs={2} sm={4} md={6} lg={6} xl={6} display="flex">
          <AvailabilityGraphComponent
            dataHistory={Array.isArray(hostHistory) ? hostHistory : []}
            data={Array.isArray(hostAvailability) ? hostAvailability : []}
            titleGraph={"Disponibilidade do Host"}
            titleHistory={"Disponibilidade do Host - Últimos 3 meses"}
            colorType={3}
            loading={loadingAvailability?.host}
            loadingHistory={loadingAvailabilityHistory.host}
            handleAplicarZoom={handleAplicarZoom}
            isZoomEnabled={true}
          />
        </Grid>
        <Grid item xs={2} sm={4} md={6} lg={6} xl={6} display="flex">
          <AvailabilityGraphComponent
            dataHistory={
              Array.isArray(interfaceHistory) ? interfaceHistory : []
            }
            data={
              Array.isArray(interfaceAvailability) ? interfaceAvailability : []
            }
            titleGraph={"Disponibilidade da Interface"}
            titleHistory={"Disponibilidade da Interface - Últimos 3 meses"}
            colorType={3}
            loading={loadingAvailability?.interface}
            loadingHistory={loadingAvailabilityHistory.interface}
            handleAplicarZoom={handleAplicarZoom}
            isZoomEnabled={true}
          />
        </Grid>
        <Grid item xs={2} sm={4} md={6} lg={6} xl={6} display="flex">
          <Paper
            sx={{
              ...styles.paperDatagrid,
              ...(alerts?.length > 10 && { height: "390px" }),
            }}
          >
            {loadingAlerts && <LinearProgress sx={styles.linearProgress} />}
            <Typography variant="h6" sx={styles.titleDatagrid}>
              Alertas - Host e Interface
            </Typography>
            <Divider />
            <Box
              sx={{
                display: "flex",
                ...(alerts?.length > 10 && { height: "390px" }),
              }}
            >
              <DatagridComponent rows={alerts} columns={columns} />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
